export default __webpack_public_path__ + "static/media/CardoBold.d7bf1aa6.ttf";